import {
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller } from "react-hook-form";

import type { FieldComponent } from "../types";

const SelectComponent: FieldComponent<never> = ({ field, methods }) => {
  const {
    formState: { errors },
  } = methods;
  const error = errors[field.name];

  return (
    <FormControl fullWidth error={Boolean(error)} disabled={field.disabled}>
      <FormLabel>{field.label}</FormLabel>
      <Controller
        name={field.name}
        control={methods.control}
        defaultValue={field.defaultValue || ""}
        render={({ field: controllerField }) => (
          <Select {...controllerField} label={field.label}>
            {field.options?.map((option) => (
              <MenuItem
                key={String(option.value)}
                value={
                  typeof option.value === "boolean"
                    ? String(option.value)
                    : option.value
                }
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {error && <FormHelperText>{error.message as string}</FormHelperText>}
    </FormControl>
  );
};

export default SelectComponent;
